import { Collection, Link } from '../../sonder/rest/representations/commons/commons';
import { SearchResultAttributes } from './handler';

const SearchResultMediaType = 'application/vnd.sas.metadata.search.result';
const SearchResultCollectionMediaType = 'application/vnd.sas.metadata.search.collection';

export const SearchResultBaseJSON = `${SearchResultMediaType}+json`;
export const SearchResultCollectionJSON = `${SearchResultCollectionMediaType}+json`;

const SearchFacetDefinitionBase = 'application/vnd.sas.metadata.definition.search.facet';
export const SearchFacetDefinitionJSON = `${SearchFacetDefinitionBase}+json`;

export interface SearchResultRepr {
  id: string;
  version?: number;
  name: string;
  type: string; // DSD~ Go definition says this is optional
  owner?: string;
  modifiedBy?: string;
  created?: string; // DSD~ Go definition says this is optional
  modified?: string; // DSD~ Go definition says this is optional
  score: number;
  attributes?: SearchResultAttributes;
  links?: Link[];
  registeredType: string;
  displayType: string;
}

export interface SearchResultCollection extends Collection<SearchResultRepr> {
  maxScore: number;
}

export interface FacetRepr {
  version: number;
  name: string;
  indices?: Array<string>;
  hiddenIndices?: Array<string>;
  type: string;
}
